/*
  ContentField_v1.js propTypes
  extracted from http://localhost:3000/documentation/resources/oaspec.json
  on 2018-04-23T13:43:27.206Z
*/

import { arrayOf, shape, string } from 'prop-types'

const ContentField_v1 = {
  content: string,
  headline: string,
}

ContentField_v1.paragraphs = arrayOf(shape(ContentField_v1))

export default ContentField_v1
